module.exports = __webpack_public_path__ + "img/setaShop.e8c300d2.svg";